<template>
  <svg
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false">
    <path d="M4 5a2 2 0 0 1 2-2h11a3 3 0 0 1 3 3v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5Zm3 1v12h10V6H7Zm2 2h6v2H9V8Zm0 4h6v2H9v-2Z"/>
  </svg>
</template>

<script>
export default {
  name: 'ComicIcon',
};
</script>

<style scoped>
svg {
  display: block;
  width: 1em;
  height: 1em;
  flex: 0 0 auto;
  fill: currentColor;
}
</style>
